// extracted by mini-css-extract-plugin
module.exports = {"SmallHeader":"VariantsFields_SmallHeader__POVyy","RemoveWrapper":"VariantsFields_RemoveWrapper__MuSok"};